import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/App";
import { translations } from "./translations";

const I18nContext = createContext({
  lang: "es",
  t: (key) => key,
  setLang: () => {},
});

const LANG_KEY = "trackomemo_lang";

export function I18nProvider({ children }) {
  const { user } = useAuth() || {};
  const [lang, setLangState] = useState(() => {
    // Read from localStorage on initial render (no need for user context)
    const stored = localStorage.getItem(LANG_KEY);
    return stored === "fr" ? "fr" : "es";
  });

  // When user logs in/out, sync per-user preference if it exists
  useEffect(() => {
    if (user?.email) {
      const userPref = localStorage.getItem(`trackomemo_lang_${user.email}`);
      if (userPref === "es" || userPref === "fr") {
        setLangState(userPref);
        localStorage.setItem(LANG_KEY, userPref);
      }
    }
  }, [user?.email]);

  const setLang = (next) => {
    setLangState(next);
    localStorage.setItem(LANG_KEY, next);
    if (user?.email) {
      localStorage.setItem(`trackomemo_lang_${user.email}`, next);
    }
  };

  const t = (key) => {
    const bucket = translations[lang] || {};
    return bucket[key] || key;
  };

  return (
    <I18nContext.Provider value={{ lang, t, setLang }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
